module.exports = __webpack_public_path__ + "media/images/badges/cyclebar/grey/RideClub_Milestones_App_250-Grey-65be5f1635e66fc8f3d926890f3af953.png";